import { Vector3 } from 'three';

export class FloatingTextUI {
  constructor(containerElement, cameraRef) {
    this.container = containerElement;
    this.camera = cameraRef;
  }

  showGoldText(worldX, worldZ, amount) {
    this._spawn(worldX, worldZ, `+${amount}g`, 'floating-text', null);
  }

  showDamageText(worldX, worldZ, amount, damageType = 'physical', isCrit = false) {
    const colors = {
      physical: isCrit ? '#fbbf24' : '#f87171',
      magic: '#a78bfa',
      true: '#f8fafc'
    };
    const color = colors[damageType] || colors.physical;
    const cls = isCrit ? 'damage-text crit-text' : 'damage-text';
    const label = typeof amount === 'string'
      ? amount
      : (isCrit ? `💥 ${Math.round(amount)}` : `${Math.round(amount)}`);
    this._spawn(worldX, worldZ, label, cls, color);
  }

  showStatusText(worldX, worldZ, text, color = '#f8fafc') {
    this._spawn(worldX, worldZ, text, 'damage-text', color);
  }

  _spawn(worldX, worldZ, text, className, color) {
    const temp = new Vector3(worldX, 2.2, worldZ);
    temp.project(this.camera);
    const div = document.createElement('div');
    div.className = className;
    div.textContent = text;
    if (color) div.style.color = color;

    // Random horizontal offset for readability when stacking
    const xOffset = (Math.random() - 0.5) * 30;
    div.style.left = `${(temp.x * 0.5 + 0.5) * 1200 + xOffset}px`;
    div.style.top = `${(-(temp.y * 0.5) + 0.5) * 800}px`;
    this.container.appendChild(div);

    const duration = className.includes('crit') ? 950 : 800;
    setTimeout(() => {
      if (div.parentNode) div.parentNode.removeChild(div);
    }, duration);
  }
}
